import app from '../common/app';
/**
 * The `Session` class defines the current user session. It stores a reference
 * to the current authenticated user, and provides methods to log in/out.
 */
export default class Session {
  /**
   * The current authenticated user.
   */

  /**
   * The CSRF token.
   */

  constructor(user, csrfToken) {
    this.user = user;
    this.csrfToken = csrfToken;
  }

  /**
   * Attempt to log in a user.
   */
  login(body, options = {}) {
    return app.request({
      method: 'POST',
      url: `${app.forum.attribute('baseUrl')}/login`,
      body,
      ...options
    });
  }

  /**
   * Log the user out.
   */
  logout() {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = `${app.forum.attribute('baseUrl')}/logout`;
    const tokenField = document.createElement('input');
    tokenField.type = 'hidden';
    tokenField.name = 'csrfToken';
    tokenField.value = this.csrfToken;
    form.appendChild(tokenField);
    document.body.appendChild(form);
    form.submit();
  }
}
flarum.reg.add('core', 'common/Session', Session);